const uploadImage = async(file)=>{

const formData = new FormData()
formData.append("image",file)

const res = await fetch(
"https://lappyshop.onrender.com/api/upload-image",
{
method:"POST",
credentials:"include",
body:formData
}
)

return res.json()

}

export default uploadImage